import { useAsiAccessDecision } from '#pplx/frontend/apps/ask/hooks/computer-access-hooks/useAsiAccessDecision.js';
import { SupportsUnifiedComputerComposerContext } from '#pplx/frontend/apps/ask/providers/SupportsUnifiedComputerComposerContext.js';
import { getAvailableComputerHarnessModes } from '#pplx/frontend/ask-models/hooks/utilities/getSearchModelConfigQuery.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useContext } from 'react';
export function useUnifiedComputerComposerEnabled(computerHarness) {
    const supportsUnifiedComputerComposer = useContext(SupportsUnifiedComputerComposerContext);
    const { status } = useSession();
    const enabled = supportsUnifiedComputerComposer && status === 'authenticated';
    const { data, isLoading, isError } = useAsiAccessDecision({ enabled });
    return (enabled &&
        !isLoading &&
        !isError &&
        data?.can_use_computer === true &&
        getAvailableComputerHarnessModes(computerHarness?.modes).includes('instant'));
}
//# sourceMappingURL=useUnifiedComputerComposerEnabled.js.map